import { fetchCMSData } from "@clients/contentfulClient";
import { mappedFactsUrlStructure } from "@utils/mappers/factsUrlStructureMapper";

import { GET_FACTS_STRUCTURE_M } from "queries/global/getFactStructure.query";
import { UrlStructureItem } from "types/UrlStructureItem";

export const getFactsUrlStructure = async (preview: boolean): Promise<UrlStructureItem[]> => {
  const { data: factStructure, errors } = await fetchCMSData(
    GET_FACTS_STRUCTURE_M(preview),
    preview,
  );
  if (errors) return;

  const mappedFactUrlStructure: UrlStructureItem[] = mappedFactsUrlStructure(
    factStructure?.insuranceHandbookPageCollection?.items,
  );
  return mappedFactUrlStructure;
};
